import { getBreakpoint } from '../utils/breakpoint-util';

class StickyNav {
    init($el) {
        this.state = {
            isSticky: false,
            scrollTimer: null
        };

        this.activeClass = 'c-nav-on-page--sticky';

        this.$el = $el;
        this.$nextEl = this.$el.nextElementSibling;
        this.offsetTop = this.$el.getBoundingClientRect().top + window.scrollY;
        this.$nav = document.querySelector('.js--nav');
        this.$navOnPage = document.querySelector('.js-nav-on-page');
        
        window.addEventListener('scroll', () => {
            this.handleScroll();
        }, false);

        this.handleAnchorPaddingTop();
    }

    /*
     * This mod is intended for on-page navigation bar `c-nav-on-page`
     * so that is sticks below the main navigation after intended scroll pos is reached
     * Works only on desktop.
     * */

    handleScroll() {

        if (this.state.scrollTimer) {
            clearTimeout(this.state.scrollTimer);
        }

        this.state.scrollTimer = setTimeout(() => {

            if (getBreakpoint() !== 'desktop') {
                return;
            }  

            let scrollY = window.scrollY || window.pageYOffset;

            let navHeight = 110;
            if(scrollY > 0) {
                setTimeout( () => {
                    navHeight = this.$nav.clientHeight;
                }, 100);
            }

            if ((scrollY + navHeight) >= this.offsetTop && !this.state.isSticky) {

                this.state.isSticky = true;
                this.$el.classList.add(this.activeClass);
                this.$el.style.top = `${navHeight}px`;
                if(this.$nextEl) {
                    this.$nextEl.style.paddingTop = `${this.$el.clientHeight}px`;
                }
            }
            else if ((scrollY + navHeight) < this.offsetTop && this.state.isSticky) {

                this.state.isSticky = false;
                this.$el.classList.remove(this.activeClass);

                this.$el.removeAttribute('style');
                if(this.$nextEl) {
                    this.$nextEl.removeAttribute('style');
                }
            }

        }, 15);
    }

    /*
     * This click handler for `c-nav-on-page__list`
     * gives extra padding top to the anchor link and remove it on scroll
     * */

    handleAnchorPaddingTop() {

        let navList = document.querySelector('.c-nav-on-page__list');
        let navListLinks =navList.getElementsByTagName('a');
        const regex = /^#[A-Za-z0-9 -]*$/g;

        for (let i = 0; i < navListLinks.length; i++) {
            const $trigger = navListLinks[i];            
            
            $trigger.addEventListener('click', (e) => { 
                const hashOk = navListLinks[i].hash.match(regex);
                let anchor = document.querySelector(navListLinks[i].hash);
                const navHeight = this.$nav.clientHeight;
                const navOnPageHeight = this.$navOnPage.clientHeight;
                let position = $(window).scrollTop();

                if (!!anchor && hashOk) {
                    let anchorRect = anchor.getBoundingClientRect();

                    if (window.pageYOffset === 0) {
                        anchor.classList.remove('js-anchor-offscreen'); 
                        anchor.style.paddingTop = `${navHeight + navOnPageHeight + 87}px`;
                    } else {
                        anchor.style.paddingTop = `${navHeight + navOnPageHeight + 20}px`;
                    }

                    if (Math.round(anchorRect.top) < 0) {
                        anchor.classList.add('js-anchor-offscreen');
                        setTimeout(() => {
                            anchor.classList.remove('js-anchor-offscreen');
                        }, 500);
                    } else {
                        anchor.classList.remove('js-anchor-offscreen');  
                    } 
                }

                $(window).scroll(function() {
                    let scroll = $(window).scrollTop();
                    
                    if (!anchor) {
                        return;
                    }
                    let checker = anchor.classList.contains('js-anchor-offscreen');
                    if (scroll < position) {
                        anchor.removeAttribute('style');
                        if (!!checker) {
                            anchor.style.paddingTop = `${navHeight + navOnPageHeight + 20}px`;
                        }
                    }
                    position = scroll;
                });

            });

        }
    }
}

[...document.querySelectorAll('.js-nav-on-page')].forEach($el => {
    const inst = new StickyNav();
    inst.init($el);
});

